


















import Vue from "vue";
import { Printer } from "@/models/Printer";

export default Vue.extend({
  props: {
    name: {
      type: String,
      default: "PrinterSettingForm"
    },
    settingData: {
      type: Object as () => Printer,
      default: null
    }
  },
  methods: {
    handleSubmit(e: Event) {
      e.preventDefault();
      this.$emit("submit", this.settingData);
    }
  }
});
